import React, { FC } from 'react';
import { NavDemo } from '../demo/nav/NavDemo';
import { NavCustomerButton } from './customers/NavCustomerButton';
import { NavLoginButton } from './login/NavLoginButton';
import { NavPublicPricing } from './pricing/NavPublicPricing';
import { NavSignupButton } from './signup/NavSignupButton';
import { withFeatures, WithFeaturesPropsType } from '../features/withFeatures';

type Props = WithFeaturesPropsType;

export const RawNavPublic: FC<Props> = ({ isFeatureEnabled }) => (
  <div className="nav" data-test-id="nav-public">
    {isFeatureEnabled('public-home/demo') && <NavDemo />}
    {isFeatureEnabled('nav-public-customers-story') && <NavCustomerButton />}
    {isFeatureEnabled('nav-demo') && <NavPublicPricing />}
    <NavLoginButton />
    <NavSignupButton />
  </div>
);

export const NavPublic = withFeatures('all')(RawNavPublic);
